export default __webpack_public_path__ + "static/media/Number_2.317337b0.svg";